import { render } from "./UserDropdown.vue?vue&type=template&id=e2295d62"
import script from "./UserDropdown.vue?vue&type=script&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&lang=ts"

import "./UserDropdown.vue?vue&type=style&index=0&id=e2295d62&lang=scss"
script.render = render

export default script